module.exports = __webpack_public_path__ + "img/iframe.95c065d5.svg";